exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-bar{position:relative;height:5px;background:#cccdc8;width:100%;overflow:hidden}.progress-bar .progress-bar__inner{position:absolute;top:0;left:0;width:0;height:100%;background:#a27c2c;transition:width 1s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TheProgressBar.vue
// module id = 397
// module chunks = 0